import SingleAdd from '@pages/lead/add-sdr/SingleAdd'
import { Modal } from 'antd'
import React from 'react'

interface TransferLeadAddModalProps {
  id: number
  open: boolean
  onCancel?: () => void
  onOk?: () => void
}

const TransferLeadAddModal = ({ open, onCancel, onOk, id }: TransferLeadAddModalProps) => {
  return (
    <Modal
      width={1200}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      footer={null}
    >
      <SingleAdd id={id} onCancel={onCancel} onOk={onOk} />
    </Modal>
  )
}

export default TransferLeadAddModal
